export function setInStorage(storage, key, value) {
  if (!storage) {
    return
  }
  try {
    if (value) {
      storage.setItem(key, value)
    } else {
      storage.removeItem(key)
    }
  } catch {
    // do nothing
  }
}
